import React from 'react';
import SuggestionsBlockUI from './SuggestionsBlockUI';
import './index.scss';
import { useGetVehicleSuggestionsQuery } from 'services/api/live-auction';

const TimeSuggestionsBlock = ({ vehicleId }) => {
  const { data, isLoading } = useGetVehicleSuggestionsQuery(vehicleId);
  const { suggestions = [], totalBeforeSuggestions = 0, totalAfterSuggestionsLength = 0 } = data ?? {};

  const getPivotIndex = React.useCallback(
    (perPage = 4) => {
      const totalLength = data.length;
      const step = Math.floor(perPage / 2);
      let pivot = Math.max(totalBeforeSuggestions - step, 0);
      if (totalLength - pivot < perPage && totalBeforeSuggestions > 2) {
        pivot = totalLength - perPage;
      }
      return Math.max(pivot, 0);
    },
    [data, totalBeforeSuggestions]
  );

  if (!suggestions.length || (!totalBeforeSuggestions && !totalAfterSuggestionsLength)) {
    return null;
  }

  return (
    <SuggestionsBlockUI
      pivotIndex={getPivotIndex(4)}
      pivotIndexMobile={getPivotIndex(2)}
      getPivotIndex={getPivotIndex}
      data={suggestions}
      isLoading={isLoading}
      blockTitle="Auction Order"
    />
  );
};

export default TimeSuggestionsBlock;
